module.exports = __webpack_public_path__ + "static/img/1.a6f3ba8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/1.jpg
// module id = Ukvx
// module chunks = 0